import React from 'react'
import SubnavLoading from './SubnavLoading'
import CenteredLoadingSpinner from './CenteredLoadingSpinner'

export default function AppLoading() {
  return (
    <>
      <SubnavLoading />
      <CenteredLoadingSpinner />
    </>
  )
}
